import { Facebook, Instagram, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
import meeLogo from "../../../assets/img/mee-logo.png";

const FamilyBusinessFooter = () => {
    return (
        <footer className="rounded-t-3xl bg-slate-50 dark:bg-[#0F172A] pt-16 pb-8 transition-theme">
            <div className="mx-auto w-full max-w-[min(100%,96rem)] px-4">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
                    {/* Brand */}
                    <div className="space-y-4 lg:col-span-2">
                        <Link to="/family-business" className="flex items-center gap-3">
                            <img src={meeLogo} alt="Mulia Executive Education" className="h-10 w-auto" />
                            <div className="flex flex-col">
                                <span className="text-xl font-bold text-gray-900 dark:text-white">Mulia Executive</span>
                                <span className="text-[10px] font-semibold text-amber-600 tracking-wider uppercase">Education</span>
                            </div>
                        </Link>
                        <p className="text-gray-500 dark:text-gray-400 text-sm leading-relaxed">
                            Membangun warisan dan masa depan bisnis keluarga Indonesia melalui edukasi dan pendampingan profesional.
                        </p>
                    </div>

                    {/* Program */}
                    <div className="space-y-4">
                        <h4 className="font-bold text-gray-900 dark:text-white">Program</h4>
                        <ul className="space-y-2 text-sm text-gray-500 dark:text-gray-400">
                            <li><Link to="/" className="hover:text-amber-600 dark:hover:text-amber-400 transition-theme-micro">Kelas Online</Link></li>
                            <li><a href="#" className="hover:text-amber-600 dark:hover:text-amber-400 transition-theme-micro">Mentoring</a></li>
                            <li><a href="#" className="hover:text-amber-600 dark:hover:text-amber-400 transition-theme-micro">Workshop</a></li>
                        </ul>
                    </div>

                    {/* Resources */}
                    <div className="space-y-4">
                        <h4 className="font-bold text-gray-900 dark:text-white">Sumber Daya</h4>
                        <ul className="space-y-2 text-sm text-gray-500 dark:text-gray-400">
                            <li><a href="#" className="hover:text-amber-600 dark:hover:text-amber-400 transition-theme-micro">Artikel & Panduan</a></li>
                            <li><a href="#" className="hover:text-amber-600 dark:hover:text-amber-400 transition-theme-micro">Studi Kasus</a></li>
                            <li><a href="#" className="hover:text-amber-600 dark:hover:text-amber-400 transition-theme-micro">Komunitas</a></li>
                        </ul>
                    </div>

                    {/* Contact */}
                    <div className="space-y-4">
                        <h4 className="font-bold text-gray-900 dark:text-white">Hubungi Kami</h4>
                        <p className="text-sm text-gray-500 dark:text-gray-400">
                            Butuh bantuan konsultasi?
                            <br />
                            <a href="mailto:family@mulia-executive.id" className="text-amber-600 hover:text-amber-700 font-medium">family@mulia-executive.id</a>
                        </p>
                        <div className="flex gap-4 pt-2">
                            <a href="#" className="w-8 h-8 rounded-xl bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 flex items-center justify-center hover:bg-amber-100 dark:hover:bg-amber-900/40 transition-theme-micro"><Facebook size={16} /></a>
                            <a href="#" className="w-8 h-8 rounded-xl bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 flex items-center justify-center hover:bg-amber-100 dark:hover:bg-amber-900/40 transition-theme-micro"><Instagram size={16} /></a>
                            <a href="#" className="w-8 h-8 rounded-xl bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 flex items-center justify-center hover:bg-amber-100 dark:hover:bg-amber-900/40 transition-theme-micro"><Linkedin size={16} /></a>
                        </div>
                    </div>
                </div>

                <div className="border-t pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
                    <p>© 2026 Mulia Executive Education. All Rights Reserved.</p>
                    <div className="flex gap-6">
                        <a href="#" className="hover:text-amber-600 transition-theme-micro">Terms</a>
                        <a href="#" className="hover:text-amber-600 transition-theme-micro">Privacy</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default FamilyBusinessFooter;
